import React from 'react';

interface IntroductionPanelProps {
  onDismiss: () => void;
  isHelpMode?: boolean;
}

const IntroductionPanel: React.FC<IntroductionPanelProps> = ({ onDismiss, isHelpMode = false }) => {
  return (
    <div className="w-full absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg z-50 border border-gray-300 max-w-md text-center">
      <h2 className="text-2xl font-bold mb-4 text-purple-700">Welcome to Dragotchi!</h2>
      <p className="mb-3 text-gray-700">
        The dragon lives persistently on this server. Feed, play, and clean to keep it alive!
      </p>
      <p className="mb-3 text-gray-700">
        Game is won at level 100.
      </p>
      <p className="mb-4 text-sm text-red-600">
        If health reaches 0, the dragon will die.
      </p>
      <button
        onClick={onDismiss}
        className="bg-purple-500 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
      >
        {isHelpMode ? 'Close' : 'Got it!'}
      </button>
    </div>
  );
};

export default IntroductionPanel; 